import React, { useState, useEffect } from 'react';

import { Container } from './styles';

type RadioProps = {
  size?: number;
  disabled?: boolean;
  handleChange?: (isCheckedValue: boolean) => void;
}

export const Radio = ({ size = 25, disabled = false, handleChange }: RadioProps) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (handleChange) handleChange(isChecked);
  }, [isChecked, handleChange])

  
  return <Container 
    size={size} 
    isChecked={isChecked} 
    onClick={() => setIsChecked(!isChecked)} 
    disabled={disabled}
  >
    {isChecked && <div className="dot" />}
  </Container>
}